import React from "react";
import { withStyles } from "@mui/styles";

import Plans from "../../../components/Plans";

const styles = theme => ({
  root: {}
});

function MyDependantCoverage(props) {
  const {
    classes,
    policyEffectiveDate,
    selectedTypes,
    selectedTiers,
    selectionDisplayMode,
    productCode,
    isDependent
  } = props;

  return (
    <div className={classes.root}>
      <Plans
        policyEffectiveDate={policyEffectiveDate}
        types={selectedTypes}
        tiers={selectedTiers}
        selectionDisplayMode={selectionDisplayMode}
        displayAll={false}
        isDependent={isDependent}
        productCode={productCode}
      />
    </div>
  );
}

export default withStyles(styles)(MyDependantCoverage);
